import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { RequestResponse } from '@/types';
import type { ChatbotSettingsData } from '@/api/mutations/chatbot/response';

/**
 * GET /chatbot/settings returns the chatbot settings.
 */
export const fetchChatbotSettings =
  async (): Promise<ChatbotSettingsData | null> => {
    try {
      const response = await axiosInstance.get<
        RequestResponse<ChatbotSettingsData>
      >(endpoints.chatbot.settings);
      const data = response.data?.data;
      return data ?? null;
    } catch {
      return null;
    }
  };
